import React from 'react';

import HtmlContentContainer from './styled/HtmlContentContainer';
import { HtmlContentProps } from './types';

const HtmlContent: React.FC<HtmlContentProps> = props => {
  return (
    <HtmlContentContainer
      css={props.customCSS}
      dangerouslySetInnerHTML={{ __html: props.html }}
    />
  );
};

export default HtmlContent;
